import CardUser from "./CardUser";
import React from "react";
import "./style.scss";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../api/module/httpClient";
import { messageDescriptorPropTypes as userProfile } from "react-intl/src/types";

export default function FacultyTab({ courseSelected }) {

  const instructors = courseSelected?.CourseClasses?.filter(i => !i.isSubclasse).reduce(
    (acc, currClass) => {
      const { CertificateClassInstructors, ...rest } = currClass;

      currClass.CertificateClassInstructors.filter(i => i.isForClass).forEach((instructor) => {
        const existingInstructor = acc.find(
          (inst) => +inst.instructor.UserId === +instructor.UserId,
        );

        if (existingInstructor) {
          existingInstructor.classes.push(rest);
        } else {
          acc.push({
            instructor,
            classes: [rest],
          });
        }
      });

      return acc;
    },
    [],
  );


  const instructorContainer = (instructors || []).map((item, index) => {
    const { instructor, classes } = item;

    return (
      <CardUser
        instructor={{
          ...instructor,
          classes: classes,
        }}
        key={index}
      />
    );
  });


  const { data } = useQuery({
    queryKey: ["GUEST_LECTURES", courseSelected?.id],
    enabled: !!courseSelected?.id,
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate/${courseSelected?.id}/guest-lecturers`);

      return data;
    },
  });

  const guestLectureContainer = Object.values(data?.guestLecturers || {}).map((value, index) => {
    return (
      <CardUser
        instructor={{
          ...value[0],
          classes: value.map(i => i.CourseClass),
        }}
        key={index}
      />
    );
  })

  const facilitatorContainer = (data?.facilitators || []).map((item, index) => {

    return (
      <CardUser
        instructor={{
          ...item,
          classes: [],
        }}
        key={index}
        btnClass={false}
      />
    );
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        alignItems: "center",
      }}
    >
      <h1>Faculty Members</h1>
      <div className="container-content-faculty-tabs-intructors">
        {instructorContainer}
      </div>
      {(guestLectureContainer).length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <h1>Guest Lecture Facilitators</h1>
          <div className="container-content-faculty-tabs-intructors">
            {guestLectureContainer}
          </div>
        </div>
      )}
      {(data?.facilitators || []).length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <h1> Hacking HR Certificate Programs Team</h1>
          <div className="container-content-faculty-tabs-intructors">
            {facilitatorContainer}
          </div>
        </div>
      )}
    </div>
  );
}